import ErrorHandler from '@classes/ErrorHandler';
import Vue from 'vue';
import App from './app';
import router from '@router/_bootstrap';
import store from '@state/store';
import '@components/_bootstrap';
import Request from '@classes/Authentication/Request';
import Response from '@classes/Authentication/Response';

// Instantiate the authentication interceptors
Request.addInterceptor();
Response.addInterceptor();

// Start our custom error handling listener
ErrorHandler.listener();

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';

// Set Vue internal error handler to throw errors up to our global error handler.
if (! window._isJavaScriptErrorLoggingDisabled) {
    Vue.config.errorHandler = error => setTimeout(() => throw error);
}

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
    // Ensure tests fail when Vue emits an error.
    Vue.config.errorHandler = window.Cypress.cy.onUncaughtException;
}

// Look for files in the plugins directory, do not look in subdirectories, and only include .js files
// https://webpack.js.org/guides/dependency-management/#require-context
const requirePlugins = require.context('./plugins', false, /[\w]+\.js/);

// Require the plugin config for each matching file name
requirePlugins.keys().forEach(file => require('./plugins/' + file.substr(2)));

// Instantiate Vue application
const app = new Vue({
    router,
    store,
    render: renderer => renderer(App),
}).$mount('#app');

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
    // Attach the app to the window, which can be useful
    // for manually setting state in Cypress commands
    // such as `cy.logIn()`.
    window.__app__ = app;
}
